import { ChatEventSubType, ChatEventType } from 'constants/chat-event-type';

interface EventWithType {
  type: ChatEventType;
  subType?: ChatEventSubType;
}

export function isSummaryEvent<T extends EventWithType>(event: T): boolean {
  return event.type === ChatEventType.Event && event.subType === ChatEventSubType.Summary;
}
